import { FooterConfig } from '@tenants/types/tenant';
import {
  getRootDomainUrl,
  getRootDomainUrlWithPath,
  getSubDomainUrl,
  RootDomain,
} from 'constants/domains';
import { EXP_REALTY_US_FOOTER_DISCLOSURES } from '../shared/exp-realty-us-footer-disclosures';

export function createFooterConfig(rootDomain: RootDomain): FooterConfig {
  const footerConfig = {
    footerColumns: {
      column1: [
        {
          label: {
            key: '',
            defaultValue: 'Explore eXp',
          },
          link: getRootDomainUrl(rootDomain),
          isAnchor: true,
          target: '_blank',
        },
        {
          label: {
            key: '',
            defaultValue: 'Find an Agent',
          },
          link: '/agents-search',
          isAnchor: true,
          target: '_blank',
        },
        {
          label: {
            key: '',
            defaultValue: 'Join eXp',
          },
          link: getSubDomainUrl(rootDomain, 'join'),
          isAnchor: true,
          target: '_blank',
        },
        {
          label: {
            key: '',
            defaultValue: 'Investor Relations',
          },
          link: 'https://expworldholdings.com/',
          isAnchor: false,
          target: '_blank',
        },
        {
          label: {
            key: '',
            defaultValue: 'Company Careers',
          },
          link: 'https://expworldholdings.com/careers/',
          isAnchor: false,
          target: '_blank',
        },
        {
          label: {
            key: '',
            defaultValue: 'Home Guides',
          },
          link: getRootDomainUrlWithPath(rootDomain, '/guides'),
          isAnchor: true,
          target: '_blank',
        },
      ],
      column2: [
        {
          label: {
            key: '',
            defaultValue: 'eXp Life',
          },
          link: getSubDomainUrl(rootDomain, 'life'),
          isAnchor: false,
          target: '_blank',
        },
        {
          label: {
            key: '',
            defaultValue: 'Zoocasa',
          },
          link: 'https://zoocasa.com/',
          isAnchor: false,
          target: '_blank',
        },
        {
          label: {
            key: '',
            defaultValue: 'SUCCESS',
          },
          link: 'https://www.success.com/',
          isAnchor: false,
          target: '_blank',
        },
        {
          label: {
            key: '',
            defaultValue: 'eXp Revenos',
          },
          link: 'https://revenos.com/',
          isAnchor: false,
          target: '_blank',
        },
        {
          label: {
            key: '',
            defaultValue: 'eXp Commercial',
          },
          link: getSubDomainUrl(rootDomain, 'www'),
          isAnchor: false,
          target: '_blank',
        },
        {
          label: {
            key: '',
            defaultValue: 'eXp Luxury',
          },
          link: 'https://expluxury.com/?tl=en',
          isAnchor: false,
          target: 'blank',
        },
        {
          label: {
            key: '',
            defaultValue: 'eXp Land and Ranch',
          },
          link: 'https://landandranch.exprealty.com/',
          isAnchor: false,
          target: '_blank',
        },
      ],
      column3: [
        {
          label: {
            key: '',
            defaultValue: 'Terms and Conditions',
          },
          link: 'https://expworldholdings.com/terms-of-service/',
          isAnchor: false,
          target: '_blank',
        },
        {
          label: {
            key: '',
            defaultValue: 'Privacy Rights Request',
          },
          link: 'https://submit-irm.trustarc.com/services/validation/e6d7516d-df9c-4404-bd9f-21a2f0d2a6a4/',
          isAnchor: false,
          target: '_blank',
        },
        {
          label: {
            key: '',
            defaultValue: 'Privacy Policy',
          },
          link: 'https://expworldholdings.com/privacy-policy/',
          isAnchor: false,
          target: '_blank',
        },
        {
          label: {
            key: '',
            defaultValue: 'Cookie Policy',
          },
          link: 'https://expworldholdings.com/cookie-policy/',
          isAnchor: false,
          target: '_blank',
        },
        {
          label: {
            key: '',
            defaultValue: 'Brand Guidelines',
          },
          link: 'https://join.exprealty.com/brand/',
          isAnchor: false,
          target: '_blank',
        },
        {
          label: {
            key: '',
            defaultValue: 'Sitemap',
          },
          link: '/sitemap',
          isAnchor: true,
          target: '_blank',
        },
      ],
      bottom: [
        ...EXP_REALTY_US_FOOTER_DISCLOSURES,
      ],
      joinUsLink: 'https://join.exprealty.com/',
      footerImageData: {
        src: '/next/assets/images/exp-footer-pic-in-service.png',
        alt: {
          key: '',
          defaultValue: 'A group of people at an event are laughing and cheering, with one man enthusiastically greeting a seated couple in the front row.',
        },
      },
    },
    showAccessibilityLink: false,
  };

  return footerConfig;
}
